import { useEffect, useRef, useState } from 'react';
import { Skeleton } from '@/shared/ui/skeleton';

/**
 * QR do link para indicar pessoalmente (balcão, mesa). Gerado no próprio
 * aparelho com `qr-code-styling` (carregado sob demanda) — o link não passa
 * por serviço de terceiros.
 */
export function ReferralQr({ url }: { url: string }) {
  const ref = useRef<HTMLDivElement>(null);
  const [status, setStatus] = useState<'loading' | 'ready' | 'error'>('loading');

  useEffect(() => {
    let cancelled = false;
    import('qr-code-styling')
      .then(({ default: QRCode }) => {
        const el = ref.current;
        if (cancelled || !el) return;
        const qr = new QRCode({
          type: 'svg',
          width: 480,
          height: 480,
          margin: 16,
          data: url,
          qrOptions: { errorCorrectionLevel: 'Q' },
          dotsOptions: { type: 'rounded', color: '#111111' },
          cornersSquareOptions: { type: 'extra-rounded', color: '#111111' },
          cornersDotOptions: { type: 'dot', color: '#111111' },
          backgroundOptions: { color: '#ffffff' },
        });
        el.replaceChildren();
        qr.append(el);
        setStatus('ready');
      })
      .catch(() => {
        if (!cancelled) setStatus('error');
      });
    return () => {
      cancelled = true;
    };
  }, [url]);

  if (status === 'error') {
    return <p className="text-center text-xs text-muted-foreground">Não foi possível gerar o QR Code.</p>;
  }
  return (
    <div className="relative mx-auto size-52 overflow-hidden rounded-2xl bg-white p-2 shadow-soft ring-1 ring-black/5">
      <div ref={ref} role="img" aria-label="QR Code do seu link de indicação" className="size-full [&>svg]:size-full" />
      {status === 'loading' ? <Skeleton className="absolute inset-0 rounded-2xl" /> : null}
    </div>
  );
}
